import { For, Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { History } from "@fleet/icons";
import { localDateKey } from "@journal/shared";
import { useOnThisDayQuery } from "@journal/shared/solid";
import { useI18n } from "@/providers/i18n-provider";
import { useJournalData } from "../hooks/use-journal-data";
import { EntryCard } from "./entry-card";

/** "On this day": entries from the same day/month in previous years. */
export function OnThisDay() {
  const { t } = useI18n();
  const { db, drizzle, userId, staleTime } = useJournalData();

  const entries = useOnThisDayQuery({
    db,
    drizzle,
    userId,
    staleTime,
    todayKey: () => localDateKey(),
  });

  return (
    <Show when={(entries.data ?? []).length > 0}>
      <section class="flex flex-col gap-3" data-testid="on-this-day">
        <h2 class="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-muted-foreground">
          <History class="h-4 w-4" />
          {t(msg`On this day`)}
        </h2>
        <For each={entries.data ?? []}>{(entry) => <EntryCard entry={entry} showDate />}</For>
      </section>
    </Show>
  );
}
